var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('SendBankPeapme',{attrs:{"order":_vm.order},on:{"mail-sent":_vm.mailSent}}),_c('v-input',{attrs:{"rules":_vm.ruleLocalValid,"type":"hidden"},model:{value:(_vm.formData._local_valid),callback:function ($$v) {_vm.$set(_vm.formData, "_local_valid", $$v)},expression:"formData._local_valid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }